import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function HeaderList(props) {
  const { children } = props;

  return (
    <div>
      { children }
    </div>
  );
}

HeaderList.propTypes = {
  children: ChildrenPropType,
};

HeaderList.defaultProps = {
  children: undefined,
};

export default HeaderList;
